import React from 'react';
import { connect } from 'react-redux';

import Spinner from '@common-components/spinner/Spinner';


const SpinnerContainer = props => {

    const {
        spinner: {
            activeSpinnersQty,
            message
        }
    } = props;

    return activeSpinnersQty > 0 ? <Spinner { ...{ message }} /> : null;
};

const mapStateToProps = state => ({
    spinner: state.common.spinner
});

export default connect(mapStateToProps)(SpinnerContainer);